module.exports = __webpack_public_path__ + "img/s.64eb6453.jpg";